import React, { useState, useRef, useCallback} from "react";
import { Link, useParams} from 'react-router-dom';
import {userActivation, reSendCodeSecurity, authenticate, isAuthenticated} from "../../auth";
import ErrorAlert from "../../pageInside/ErrorAlert";
import VerificationCodeInput from "../../../components/security/VerificationCodeInput";

const ActivatorPageAss = (props) => {

    const {
        laguangeElakay,
        infoSource,
        token
    }=props
    let params = useParams()
    const [error, setError] = useState(null);
    const [values, setValues] = useState({
        numberDigi: "",
        loading: false,
        Suc: false,
        redirectToReferrer: false
    });

    const { numberDigi, loading, Suc,  redirectToReferrer } = values;
    // Guards against double-submission when onComplete auto-fires as soon
    // as the 6th digit is entered -- reset on error/resend so a corrected
    // code can be auto-verified again.
    const lastSubmittedCodeRef = useRef("");

    const clickSubmit = (codeOverride) => {
        const codeToSubmit = codeOverride ?? numberDigi;
         setError(null)
        localStorage.removeItem("elakayUser");
        setValues({ ...values, loading: true });
        userActivation({token, numberDigi: codeToSubmit})
            .then(data => {
                if (data.error) {
                     lastSubmittedCodeRef.current = "";
                     setError(data.error)
                    setValues({ ...values, loading: false, Suc: false});
                } else {
                    localStorage.removeItem("token_userAdding")
                     setError(null)
                    // authenticate() itself opens the signed-in app (once).
                    authenticate(data, () => {
                        setValues({
                            ...values,
                            redirectToReferrer: true
                        });
                    });
                }
            });
    };

    // Auto-submit as soon as the 6th digit is entered.
    const handleAutomaticVerification = useCallback((code) => {
        if (!/^\d{6}$/.test(code)) return;
        if (loading || lastSubmittedCodeRef.current === code) return;
        lastSubmittedCodeRef.current = code;
        clickSubmit(code);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, values]);

    const resendCode = () => {
         setError(null)
        setValues({ ...values, loading: true });
        reSendCodeSecurity({ token, numberDigi })
            .then(data => {
                if (data.error) {
                    setError(data.error)
                    setValues({ ...values,  loading: false, Suc: false});
                } else {
                     lastSubmittedCodeRef.current = "";
                     setError(null)
                    setValues({
                        ...values,
                        numberDigi: "",
                        Suc: true,
                        loading: false
                    });
                }
            });
    };


    const signUpForm = () => (


        <div>
<div className="form-signin">

            <form >
                    <h6 className="text-center m-4">{infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text0}</h6> <h6 className="text-center m-4">{infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text2}</h6>
                {showLoading()}
                {showError()}
                {suscceSendCode()}

                {/* Shared 6-box OTP component (auto-advance, paste, autofill,
                    auto-submit on the 6th digit) -- same component used by
                    active.js and Signin.js. */}
                <div className="form-label-group">
                    <label htmlFor="inputNumberdigi" className="d-block text-center mb-2">
                        {infoSource.laguangeElakay('label', infoSource.languageAPI).secuCode}
                    </label>
                    <VerificationCodeInput
                        value={numberDigi}
                        onChange={(next) => setValues({ ...values, Suc: false, numberDigi: next })}
                        onComplete={handleAutomaticVerification}
                        disabled={loading}
                        hasError={Boolean(error)}
                        ariaLabel={infoSource.laguangeElakay('label', infoSource.languageAPI).secuCode || "6-digit verification code"}
                        autoFocus
                    />
                </div>


                <input type="hidden" name="verication" placeholder="" />

            </form>
            <div className="form-group mt-4">
                    <button className="btn btn-outline-primary" onClick={() => clickSubmit()} >{infoSource.language(infoSource, 'Button', "submit")}</button>
            </div>
                <h6 className="text-center m-4">{infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text4}</h6>
                <h6 className="text-center m-4"> <Link to="#" onClick={() => resendCode()}>{infoSource.laguangeElakay('Link', infoSource.languageAPI).newCode} </Link> </h6>
                <ErrorAlert error={error} setError={setError} duration={10000} />
        </div>
        </div>
    );

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{ display: error ? "" : "none" }}
        >
            {error}
            <h6 className="text-center m-4"> <Link to="/Signup">{infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount}</Link> </h6>
        </div>
    );



    const showLoading = () =>
        loading && (
            <div className="alert alert-info">
                <h2>
                    {/* Loading... */}
                    {infoSource.language(infoSource, "title", "loanding")}
                    </h2>
            </div>
        );

    const suscceSendCode = () =>
        Suc && (
            <div className="alert alert-info"
                style={{ display: Suc ? "" : "none" }}
            >
                <h6 className="text-center m-4">{infoSource.laguangeElakay('signinPage', infoSource.languageAPI).text5}</h6>
                <h6 className="text-center m-4"> <Link to="/Signup">{infoSource.laguangeElakay('Button', infoSource.languageAPI).creatAccount}</Link> </h6>
            </div>
        );

  
    // const redirectUser1 = () => {
    //     if (redirectToReferrer) {
    //         return window.location.href = '/signin';
    //     }
    // }
    // const redirectUser = () => { 
    //     if (isAuthenticated()) {
    //         return navigate("/")
    //            }
    //        }
   

    return (
        <div>
            {signUpForm()}
            {/* {redirectUser1()} */}
            {/* {redirectUser()} */}
            {/* {redirectUser0()}
            {redirectUser1()} */}

        </div>
    );
};
export default ActivatorPageAss;
